import { render, staticRenderFns } from "./PingAnTrunkInvoiceInfo.vue?vue&type=template&id=1981d31e&scoped=true"
import script from "./PingAnTrunkInvoiceInfo.vue?vue&type=script&lang=js"
export * from "./PingAnTrunkInvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./PingAnTrunkInvoiceInfo.vue?vue&type=style&index=0&id=1981d31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981d31e",
  null
  
)

export default component.exports